(function ($) {
    $.fn.videoSliderCarousel = function () {
        return this.each(() => {
            const $self = $(this);
            let slideCount = $self.find('.thumbnail-slider.splide .splide__slide').length;
            let mainSlider = $self.find('.main-slider');
            let thumbnailSlider = $self.find('.thumbnail-slider');
            if(slideCount < 4)
                $self.find('.thumbnail-slider').addClass('no-arrow');


            var slider = new window.Splide( mainSlider[0], {
                type       : 'fade',
                cover      : true,
                rewind     : true,
                pagination : false,
                heightRatio: 0.5,
                arrows: false,
                fixedWidth  : 710,
                fixedHeight : 450,
            });

            var main = new window.Splide( thumbnailSlider[0], {
                fixedWidth  : 230,
                fixedHeight : 120,
                gap         : 10,
                rewind      : true,
                pagination  : false,
                cover       : true,
                isNavigation: true,
                arrows: (slideCount < 4 ? false : true),
                breakpoints : {
                  800: {
                    fixedWidth : 210,
                    fixedHeight: 140,
                  },
                  600: {
                    fixedWidth : 170,
                    fixedHeight: 100,
                  },
                },
            });

           // slider.sync( main );
            main.mount();
            slider.mount();

            $('.play-btn').on('click', function(e) {
              $(this).hide();
              $(this).next('.youtube-title').hide();
              $(this).prev('iframe').show();
              $(this).prev('iframe')[0].src +='?autoplay=1';
              e.preventDefault();
            });

            $('#thumbnail-slider li').on('click', function() {
                var thumbnailSrc = $(this).find('img').attr('src');
                $('#main-slider li.is-active .video-block').css('background-image', 'url('+thumbnailSrc+')');

                $(this).attr('src', '');
                var videoUrl = $(this).attr('data-url');
                var videoTitle = $(this).attr('data-title');
                $('#main-slider li.is-active iframe').attr('src', videoUrl);
                $('#main-slider li.is-active .youtube-title').html(videoTitle);
           });



        });

    }

    $(() => {
        $('.video_slider_carousel').videoSliderCarousel();
    })

})($);



// WEBPACK FOOTER //
// ./scripts/modules/blocks/video-slider.js